import en from './en.json';
import de from './de.json';

const languages = {
  en: {
    name: 'English',
    translation: en,
  },

  de: {
    name: 'Deutsch',
    translation: de,
  },
};

export default languages;
